<header class="navigation">
  <!-- Logo -->
  <a routerLink="/dashboard" class="logo">
    <img [src]="logoPath">
  </a>

  <div class="content">
    <!-- "Première ligne" du header -->
    <section class="header-menu">
      <!-- Barre de recherche -->
      <div class="input-group search"
        [ngSwitch]="(!!context.orderCode || context.customerCode && fullContext.company?.settings.showOfferWithoutOrder)">
        <div class="test-elk-holder">
          <div class="test-elk" *ngIf="useTestElkConfig">Test ELK</div>
        </div>

        <ng-container *ngSwitchCase="true">
          <button class="btn input-group-btn" (click)="handleSearchClick(searchInput.value)">
            <i class="fa fa-search"></i>
          </button>
          <!-- <input type="text" *ngIf="fullContext?.company?.code != 'VITAFRAIS'" [(ngModel)]="searchService.term" name="searchTerm" #searchInput
            class="input-group-addon form-input"
            [attr.placeholder]="!contextService.isUserKiwi() ? 'Rechercher un produit (marque, ean, ...)' : 'Rechercher un produit (code Pronadis, marque...)'"
              (keyup)="keyup($event)">  -->
          <div class="product-picker-holder">
            <app-product-picker class="product-picker"></app-product-picker>
          </div>

        </ng-container>
        <ng-container *ngSwitchCase="false">
          <button class="btn input-group-btn tooltip tooltip-bottom" disabled
            [attr.data-tooltip]="'header.noSearchWithoutOrder' | translate">
            <i class="fa fa-search"></i>
          </button>
          <input type="text" #searchInput class="input-group-addon form-input"
            [attr.placeholder]="'header.searchPlaceholder' | translate" disabled>
        </ng-container>
      </div>

      <!-- "Partie droite" -->
      <div class="user-part d-flex hide-lg">

        <ng-container *ngIf="authenticationService.isLoggedIn()">
          <!-- Société -->

          <div class="dropdown header-element" *ngIf="context.companyCode as selectedCompanyCode">
            <!-- <button class="tile tile-centered btn btn-link" title="{{ this.fullContext.company?.label }}"
                    [ngClass]="{'dropdown-toggle': (availableCompanies?.length > 0), 'disabled-dropdown': (availableCompanies?.length === 0)}">
              <i class="fa fa-shopping-bag centered"></i>
              <span class="tile-subtitle">{{ this.fullContext.company?.label }}</span>
            </button>
            <ul class="menu">
              <li *ngFor="let company of availableCompanies" class="menu-item" (mousedown)="onCompanySelected(company.code)">
                <a>{{ company.label }}</a>
              </li>
            </ul> -->

            <!-- On verrifie si l'utilisateur a plusieurs société disponible pour lui afficher le bouton de changement de société -->
            <div class="ctn-btn-societe" *ngIf="availableCompanies?.length > 0">
              <a [class]="contextService.isVitafrais() ? 'btn-pronatura btn btn-rounded' : 'btn-vitafrais btn btn-rounded'"
                (click)="onCompanySelected(contextService.isVitafrais() ? 'PRONATURAFRANCE' : 'VITAFRAIS')">
                <span *ngIf="contextService.isVitafrais()">ProNatura</span>
                <span *ngIf="!contextService.isVitafrais()">Vitafrais</span>
              </a>
            </div>
          </div>

          <!-- Voir catalogue -->
          <a *ngIf="context.customerCode" [routerLink]="['/offers']"
            class="btn btn-rounded btn-company mx-1 hide-lg"
            [ngClass]="{'disabled': !context.orderCode && !fullContext.company?.settings.showOfferWithoutOrder }">
            <span class="dashboard-text">{{ 'dashboard.checkCatalog' | translate }}</span>
          </a>

          <!-- Créer une commande -->
          <a *ngIf="context.customerCode" id="create-order" class="btn btn-rounded btn-highlight mx-1 hide-lg"
            (click)="newOrder()">
            <span class="dashboard-text">{{ 'dashboard.createOrder' | translate }}</span>
          </a>

          <!-- Demande de rappel -->
          <div>
            <div class="container-rappel">
              <a *ngIf="context.customerCode" matTooltip="" class="btn btn-border-none mx-1 "
                (click)="callbackRequest()">
                <i class="fa fa-phone"></i><span class="hide-xl">{{ 'buttons.callbackRequest' | translate }}</span>
              </a>
              <div class="container-profile" *ngIf="businessContact != null">

                <div class="flex label-name">
                  <div class="name">{{ businessContact.firstName }} {{ businessContact.lastName }}</div>
                </div>
                <div class="label-role" *ngIf="businessContact.role">{{ businessContact.role }}</div>
                <div class="label-role" *ngIf="!businessContact.role">Commercial(e) Sédentaire</div>
                <div class="flex" *ngIf="businessContact.phoneNumber">
                  <div>
                    <i class="fa fa-phone"></i>
                  </div>
                  <div>
                    <a [href]="'mailto:' + businessContact.phoneNumber">{{ businessContact.phoneNumber }}</a>
                  </div>
                </div>
                <div class="flex" *ngIf="businessContact.email">
                  <div>
                    <i class="fa fa-envelope"></i>
                  </div>
                  <div>
                    <a [href]="'mailto:' + businessContact.email">{{ businessContact.email }}</a>
                  </div>
                </div>
                <a *ngIf="context.customerCode" matTooltip=""
                  class="btn btn-rounded btn-highlight btn-border-none mx-1 flex-centered" (click)="callbackRequest()">
                  <i class="fa fa-phone"></i><span class="hide-xl">{{ 'buttons.callbackRequest' | translate }}</span>
                </a>
              </div>
            </div>

          </div>

          <div class="user-icon-holder tooltip tooltip-left"
            [attr.data-tooltip]="userLogin + '\n' + businessInformationToDisplay">
            <!-- Icon "User" -->
            <app-user [userCode]="context.userCode"></app-user>
          </div>
        </ng-container>
       

        <!-- Langue -->
        <div class="dropdown header-element languages">
          <button class="btn btn-link dropdown-toggle">
            <span class="language-flag {{ activeLanguage | async }}"></span>
          </button>

          <!-- Liste des langues disponibles -->
          <ul class="menu">
            <li *ngFor="let language of languages" class="menu-item" (mousedown)="languageEmitted(language)">
              <a>
                <span class="language-flag {{ language }}"></span> {{ 'language.' + language | translate }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Bouton Wizards avec modale -->
        <div class="wizard-menu-container" *ngIf="context.customerCode">
          <button id="btn-guide-interactif" class="btn btn-link btn-wizard-trigger tooltip tooltip-left"
            [attr.data-tooltip]="'Guides interactifs'" (click)="toggleWizardMenu($event)">
            <i class="fa fa-fw fa-magic"></i>
          </button>

          <!-- Modale des wizards -->
          <div class="wizard-modal" *ngIf="showWizardMenu" [@slideDown]>
            <!-- Header avec gradient -->
            <div class="wizard-modal-header">
              <div class="header-content">
                <div class="header-icon">
                  <i class="fa fa-magic"></i>
                </div>
                <div class="header-text">
                  <h4>Guides interactifs</h4>
                  <p>Découvrez toutes les fonctionnalités</p>
                </div>
              </div>
              <button class="btn-close" (click)="closeWizardMenu()">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <app-wizard-menu [inline]="false" [theme]="'light'" (close)="closeWizardMenu()">
            </app-wizard-menu>
          </div>
        </div>

        <!-- Overlay -->
        <div class="wizard-overlay" *ngIf="showWizardMenu" (click)="closeWizardMenu()"></div>

        <!-- Bouton logout -->
        <a class="btn btn-border-none mx-1 tooltip tooltip-left" [attr.data-tooltip]="'buttons.logout' | translate"
          (click)="authenticationService.logout()">
          <i class="fa fa-fw fa-sign-out-alt"></i>
        </a>
      </div>

      <!-- Menu burger en mode tablette -->
      <div class="d-flex show-lg">
        <button id="mobile-main-hamburger-button" class="btn btn-action hamburger-menu"
          [ngClass]="{'btn-primary': showSideMenu}" (click)="toggleSideMenu()">
          <i class="fa fa-bars"></i>
        </button>
      </div>
    </section>

    <!-- "Deuxième ligne" du header -->
    <section class="header-context-info flex-centered">
      <div class="columns">
        <!-- Partie informations client -->
        <app-context-banner [adresseLivraison]="adresseLivraison" (reactivateOrderEmitter)="reactivateOrder()"
          [remainingTime]="remainingTime$ | async" [validityRate]="validityRate$ | async"
          *ngIf="context.customerCode"></app-context-banner>

        <div class="flex-centered hide-lg" *ngIf="contextOrder && context.orderCode">
          <!-- Panier -->
          <a [routerLink]="'/order-in-progress'" class="tile tile-centered header-element mr-2">
            <i class="fa fa-shopping-cart fa-fw centered"></i>
            <div class="tile-subtitle" *ngIf="contextOrder.count > 0; else noArticle">
              <!-- <ng-container *ngIf="contextOrder.weight?.net || contextOrder.weight?.gross">{{ (contextOrder.weight?.net || contextOrder.weight?.gross) + contextOrder.weight?.unit }}</ng-container>
              <ng-container *ngIf="contextOrder.price?.total && (contextOrder.weight?.net || contextOrder.weight?.gross)"> | </ng-container> -->
              <ng-container *ngIf="(contextService.fullContext$ | async)?.order?.price?.total as total">
                {{ total + ' ' + (contextService.fullContext$ | async)?.order?.price?.unit | euroSymbol }}
              </ng-container>
              <ng-container
                *ngIf="!contextOrder.price?.total && !(contextOrder.weight?.net || contextOrder.weight?.gross)">{{
                contextOrder.count }} {{ (contextOrder.count > 1 ? 'order.countPlural' : 'order.countSingular') |
                translate}}</ng-container>
            </div>
            <ng-template #noArticle>
              <div class="tile-subtitle">{{ 'order.emptyCount' | translate }}</div>
            </ng-template>
          </a>

          <!-- Atteinte du franco -->
          <div class="ctn-btn-franco">
            <app-franco [contextOrder]="contextOrder" [contextFranco]="contextFranco"
              [isFrancoUnique]="fullContext?.customer?.isFrancoUnique ? true : false"
              [isFrancoAmenage]="fullContext?.customer?.isFrancoAmenage"></app-franco>
          </div>

          <!-- Temps restant avant fin de validité du panier -->
          <app-remaining-time-order
            *ngIf="contextOrder.validityEndDate && contextOrder.status === orderStatusEnum.CREATED && (validityRate$ | async) >= 0"
            [remainingTime]="remainingTime$ | async" [validityRate]="validityRate$ | async"
            [validityEndDate]="contextOrder.validityEndDate" [cutOffPreco]="contextOrder.cutOffPreco" [mobile]="false">
          </app-remaining-time-order>

          <!-- Bouton de réactivation de la commande -->
          <a (click)="reactivateOrder()" *ngIf="contextOrder.status === orderStatusEnum.INACTIVE"
            class="btn btn-border-none tooltip reactivate" [attr.data-tooltip]="'buttons.reactivateOrder' | translate">
            <i class="fa fa-redo-alt"></i>
          </a>
        </div>
      </div>
      <div style="display: flex;">
        <!-- Favoris -->
        <a *ngIf="context.companyCode as selectedCompanyCode" [routerLink]="['/user/aidealavente/']"
          class="btn btn-rounded btn-company-colored mx-2 hide-lg">
          <span class="dashboard-text">Mes outils d'aide à la vente</span>
        </a>
        <a *ngIf="context.companyCode as selectedCompanyCode" [routerLink]="['/offers/favorites']"
          class="tile tile-centered mr-2 header-element hide-lg container-favorites"
          [ngClass]="{'disabled': !context.orderCode && !fullContext.company?.settings.showOfferWithoutOrder }">

          <i class="fa fa-heart col-mr-1"></i>
          <!-- <span matBadgeSize="small" matBadge="{{ this.favoriteService.countFavorites }}" matBadgePosition="after" matBadgeColor="warn" class="tile-subtitle">Mes produits</span> -->
          <span class="tile-subtitle hide-xl">Mes produits</span>
          <span class="nb-favorites">{{ this.favoriteCount }}</span>
        </a>
      </div>
    </section>
  </div>

  <!-- Mode mobile -->
  <app-mobile-menu [ngClass]="{'active': showSideMenu}" (callbackEmitter)="callbackRequest()"
    (startScanEmit)="startScan()" (clickOutside)="onClickOutside()" (languageEmitter)="languageEmitted($event)"
    [order]="contextOrder" [activeLanguage]="activeLanguage" [availableLanguages]="languages"></app-mobile-menu>
</header>